import Button from '@platform-ui-common/components/Button/index.js';
import Markdown from '@platform-ui-common/components/Markdown/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import Color, { BorderColors } from '@platform-ui-common/utilities/Color.js';
import { StatusBlockChip } from '@platform-ui/application/components/StatusBlock/index.js';
import { ApplicationStatusBlock } from '@platform-ui/application/hooks/useApplicationStatusBlocks/types.js';
import { Fragment } from 'react';

export default function StatusBlock({
  id,
  chips,
  title,
  message,
  button,
}: ApplicationStatusBlock): JSX.Element {
  return (
    <Fragment key={id}>
      <hr className={`w-full max-w-[20rem] border-t ${BorderColors[Color.InputBorder]}`} />
      <div data-cy={id} className="flex flex-col gap-4">
        {chips?.length > 0 && (
          <div className="flex gap-2">
            {chips.map((chip) => (
              <StatusBlockChip key={chip} chip={chip} />
            ))}
          </div>
        )}
        <div className="flex flex-col gap-2">
          <Typography variant="body" bold>
            {title}
          </Typography>
          <Markdown variant="body">{message}</Markdown>
        </div>
        <div className="flex mt-1">
          <Button {...button} variant="tertiary" />
        </div>
      </div>
    </Fragment>
  );
}
